import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageStaff = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [allData, setAllData] = useState([]);

  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([
    {
      _id: 1,
      name: "sales",
    },
    {
      _id: 2,
      name: "survey",
    },
    {
      _id: 3,
      name: "telecalling",
    },
    {
      _id: 4,
      name: "data entry",
    },
    {
      _id: 5,
      name: "branch manager",
    },
    {
      _id: 6,
      name: "freelancer",
    },
  ]);

  const [uploading, setUploading] = useState(false);
  const [cities, setCities] = useState([]);

  const initialFormData = {
    name: "",
    email: "",
    city: "",
    role: "",
    qualification: "",
    designation: "",
    phoneNo: 0,
    salary: 0,
    photo: "",
    password: "",
    // rawPassword:""
  };
  const [formData, setFormData] = useState(initialFormData);
  const [editID, setEditID] = useState("");
  const [selectedCityID, setSelectedCityID] = useState("");

  const handleChange = (e) => {
    e.preventDefault();

    let name = e.target.name;
    let value = e.target.value;

    if (name === "phoneNo" || name === "salary") {
      value = parseInt(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleFileUpload = async (e) => {
    setUploading(true);
    const file = e.target.files[0];
    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData({ ...formData, [e.target.name]: res.image });
        setUploading(false);
      }
    } catch (error) {
      toast.error(`Upload Failed.`);
      console.error(`Error uploading:`, error);
    }
  };

  const fetchAllData = async () => {
    try {
      const response = await HomeService.getStaffs();
      console.log("All Staffffffffff", response?.data);
      const formattedData = response?.data.map((staff, index) => ({
        id: staff._id,
        sln: index + 1,
        cityName: staff?.city?.name,
        designationName: staff.designation.name,
        city: staff?.city?._id,
        designation: staff.designation._id,
        email: staff.email,
        name: staff.name,
        phoneNo: staff.phoneNo,
        photo: staff.photo,
        qualification: staff.qualification,
        role: staff.role,
        salary: staff.salary,
        password: staff?.rawPassword,
        action: (
          <>
            {loggedUserID !== staff._id && (
              <>
                <span title="Edit" onClick={() => handleEdit(staff)}>
                  <i
                    className="fa-solid fa-pen-to-square"
                    style={{
                      cursor: "pointer",
                      padding: "5px",
                      marginRight: "5px",
                      fontSize: "1.5em",
                      color: "rgb(133, 218, 79)",
                      backgroundColor: "#E9F3F7",
                    }}
                  ></i>
                </span>
                <span title="Delete" onClick={() => handleDelete(staff._id)}>
                  <i
                    className="fa-solid fa-trash"
                    style={{
                      cursor: "pointer",
                      padding: "5px",
                      marginRight: "5px",
                      fontSize: "1.5em",
                      //   color: " #477DA5",
                      color: " red",
                      backgroundColor: "#E9F3F7",
                    }}
                  ></i>
                </span>
              </>
            )}
          </>
        ),
      }));

      console.log("DSE32", formattedData);
      if (userCity) {
        setAllData(formattedData.filter((item) => item?.city === userCity));
      } else {
        setAllData(formattedData || []);
      }
    } catch (error) {
      console.error("Error fetching Staffs:", error);
    }
  };

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  // Fetch Designations
  const fetchDesignations = async () => {
    try {
      const res = await HomeService.getDesignations();
      if (res?.data) {
        setDesignations(res.data);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  console.log("UYT189", loggedUserID);

  useEffect(() => {
    setRoles(roles.filter((role) => role.name !== userRole));
    fetchAllData();
    fetchCities();
    fetchDesignations();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Deleting Staff...",
      text: "Are you sure you want to delete this staff ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "No, not sure!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteStaff(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Staff record has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete stadd record.", "error");
      }
    }
  };

  const handleEdit = (data) => {
    setEditID(data?._id || "");
    console.log("HRE206", {
      ...data,
      city: data.city._id,
      designation: data.designation._id,
    });

    setFormData({
      ...data,
      city: data.city._id,
      designation: data.designation._id,
      password: data?.rawPassword,
    });

    const editSection = document.getElementById("edit-section");
    if (editSection) {
      editSection.scrollIntoView({
        behavior: "smooth", // Smooth scrolling
        block: "start", // Align to the top of the section
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData?.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    if (formData?.phoneNo?.toString()?.length !== 10) {
      toast?.error("Contact Number should be in 10 digits");
      return;
    }
    try {
      console.log("updated submitted data", formData);

      const res = await HomeService.updatStaff(editID, formData);
      if (res?.status) {
        fetchAllData();
        setEditID(null);
        toast.success("Staff data updated successfully!");
      }
    } catch (error) {
      toast.error("Failed to update staff.");
      console.error("Error updating staff:", error);
    }
  };

  const columns = [
    { name: "Sl#", selector: (row) => row.sln, sortable: true },
    {
      name: "Photo",
      cell: (row) => (
        <img
          src={row?.photo}
          style={{ maxWidth: "100%", maxHeight: "96px", padding: "10px 0" }}
        />
      ),
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email, wrap: true },
    { name: "Password", selector: (row) => row.password, wrap: true },
    { name: "City", selector: (row) => row.cityName },
    { name: "Qualification", selector: (row) => row.qualification },
    { name: "Contact", selector: (row) => row.phoneNo, sortable: true },
    { name: "Salary", selector: (row) => row.salary, sortable: true },
    { name: "Role", selector: (row) => row.role, sortable: true, wrap: true },
    {
      name: "Designation",
      selector: (row) => row.designationName,
      sortable: true,
    },
    // {
    //     name: "Status",
    //     cell: (row) => (
    //         <button
    //             className={`btn btn-${row.status === true ? "success" : "danger"}`}
    //             onClick={() => toggleStatus(row.id, row.status)}
    //         >
    //             {row.status === true ? "Active" : "Inactive"}
    //         </button>
    //     ),
    // },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
      style: { textAlign: "center" },
    },
  ];

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Staff Data", 14, 20);

    const tableColumn = [
      "Sl#",
      "Name",
      "Email",
      "City",
      "Qualification",
      "Contact",
      "Salary",
      "Role",
      "Designation",
    ];

    const tableRows = allData.map((row) => [
      row.sln,
      row.name,
      row.email,
      row.cityName,
      row.qualification,
      row.phoneNo,
      row.salary,
      row.role,
      row.designationName,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    doc.save("staff-data.pdf");
  };

  // 🔹 Excel Download Function
  const downloadExcel = () => {
    const worksheetData = allData.map((row) => ({
      "Sl#": row.sln,
      Name: row.name,
      Email: row.email,
      City: row.cityName,
      Qualification: row.qualification,
      Contact: row.phoneNo,
      Salary: row.salary,
      Role: row.role,
      Designation: row.designationName,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Staff");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "staff-data.xlsx");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid" id="edit-section">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Manage All Staff
          </h2>
          <div
            style={{
              marginBottom: "15px",
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
            }}
          >
            <button
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "#73fc03",
                fontWeight: "600",
                border: "none",
              }}
              onClick={downloadPDF}
            >
              Download PDF ({allData?.length})
            </button>
            <button
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "#73fc03",
                fontWeight: "600",
                border: "none",
              }}
              onClick={downloadExcel}
            >
              Download Excel ({allData?.length})
            </button>
          </div>
          <section className="chartBox_area">
            {editID ? (
              <>
                <h3>View/Modify Staff Data</h3>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 mt-3">
                      {uploading ? (
                        <>
                          <label>
                            <span className="text-success">Uploading...</span>
                          </label>
                        </>
                      ) : formData.photo ? (
                        <></>
                      ) : (
                        <>
                          <label>Photo</label>
                        </>
                      )}
                      {formData.photo && (
                        <div className="mb-2">
                          <img
                            src={formData.photo}
                            alt="Logo Preview"
                            width="100"
                            style={{ display: "block", marginTop: "10px" }}
                          />
                        </div>
                      )}
                      <input
                        type="file"
                        name="photo"
                        className="form-control"
                        onChange={(e) => handleFileUpload(e)}
                        accept="image/*"
                      />
                    </div>

                    <div
                      className="col-md-4 mt-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label>
                        Full Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData?.name}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Full Name"
                        required
                      />
                    </div>
                    <div
                      className="col-md-4 mt-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label>
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData?.email || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Email address"
                        required
                      />
                    </div>
                    <div
                      className="col-md-4 mt-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label>
                        Password<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="password"
                        value={formData?.password || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Password"
                        required
                      />
                    </div>

                    {/* <div className="col-md-6 mt-3">
                                        <label>
                                            Password<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="password"
                                            value={formData?.password || ""}
                                            onChange={(e) => handleChange(e)}
                                            placeholder="Enter Password"
                                            required
                                        />
                                    </div> */}

                    <div className="col-md-4 mt-3">
                      <label>
                        City<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="city"
                        value={formData?.city || ""}
                        onChange={(e) => handleChange(e)}
                        required
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {cities.map((city) => (
                          <option key={city._id} value={city._id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mt-3">
                      <label>
                        Role<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="role"
                        value={formData?.role || ""}
                        onChange={(e) => handleChange(e)}
                        required
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {roles.map((item, index) => (
                          <option key={index} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mt-3">
                      <label>
                        Designation<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="designation"
                        value={formData?.designation}
                        onChange={(e) => handleChange(e)}
                        required
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {designations.map((item, key) => (
                          <option key={key} value={item._id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>
                        Salary<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="salary"
                        value={formData?.salary || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter salary"
                        required
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        Qualification<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="qualification"
                        value={formData?.qualification || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter qualification"
                        required
                      />
                    </div>

                    <div className="col-md-3 mt-3">
                      <label>
                        Contact Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="phoneNo"
                        value={formData?.phoneNo || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter phone number"
                        required
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary mt-3">
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    style={{ marginLeft: "11px" }}
                    onClick={() => setEditID(null)}
                  >
                    Cancel
                  </button>
                </form>
              </>
            ) : (
              <DataTable columns={columns} data={allData} pagination />
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ManageStaff;
